(function(){
  Pegasus.PexelsImagesController = Em.Controller.extend({
    needs: ['imageGallery', 'upload', 'frameCommManager'],
    staggerResults: true,
    breakValue: 3,
    request: function(query, page, count) {
      var params = [
        'page=' + page,
        'per_page=' + count
      ];

      params.unshift(query || 'business');
      var baseURL = '/pexels_search.json?pexels_query=';

      this.get('controllers.frameCommManager').requestPexelsImagesFor(
        baseURL + params.join('&'), this
      );
    },
    didCompleteRequest: function(data){
      Em.run( this.get('controllers.imageGallery'), 'send', 'didRetrieveImages', data, this);
    },
    didFailRequest: function(err){
    },
    useThis: function(view, size){
      var content = view.get('content');
      var src;

      src = content.data.src[size];

      this.set('controllers.upload.dataSrcProxy', src);
      this.get('controllers.upload').send('didReplaceImage');
    },
    sizeContent: function(view){
      var actual = $('<img src="' + view.get('content.src') + '" />');

      if ( !view.get('content.naturalWidth') ) {
        actual.imagesLoaded().
          done(function(img){
            Em.run.next(img, function(){
              try {
                view.set('content.naturalWidth', this.images[0].img.naturalWidth);
                view.set('content.naturalHeight', this.images[0].img.naturalHeight);
              }catch(e){}
            });
          }).
          fail(function(img){
            alert('fail');
          });
      }
    },
    didSelectImage: Em.K
  });
})();
